import { render } from 'datocms-structured-text-to-plain-text';
import { type ReactElement } from 'react';
import { type FAQPage, type Question, type WithContext } from 'schema-dts';

import {
  SeoStructuredDataScript,
  getRegionOrganizationUrl,
} from '@/app/components/server/seo-structured-data-script';
import { type BasePageParams } from '@/app/urls/url-mapping';
import { type ExpandCollapseCard } from '../expand-collapse-card';

type Props = {
  cards: Array<Pick<ExpandCollapseCard, 'content' | 'title'>>;
  params: Pick<BasePageParams, 'language' | 'region'>;
};

export const SeoFaqPageStructuredData = (props: Props): ReactElement => {
  const { cards, params } = props;
  const { language } = params;

  const mainEntity: Question[] = cards.map(
    (card: ExpandCollapseCard): Question => {
      const { content, title } = card;
      const text = render(content) ?? '';
      return {
        '@type': 'Question',
        acceptedAnswer: { '@type': 'Answer', text },
        name: title,
      };
    }
  );

  const faqPage: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: language,
    mainEntity,
    publisher: getRegionOrganizationUrl(params),
  };

  return <SeoStructuredDataScript structuredData={faqPage} />;
};
